import { combineReducers } from "redux"
import usersClientReducer from "./UserClientReducer"
import usersInternalReducer from "./UserInternalReducer"
import usersPartnerReducer from "./UserPartnerReducer"
import usersMembershipReducer from "./UserMembershipReducer"


const rootReducerUsers = combineReducers({
    usersInternal : usersInternalReducer,
    usersClient : usersClientReducer,
    usersPartner : usersPartnerReducer,
    usersMembership : usersMembershipReducer
})

export default rootReducerUsers
